module.exports = __webpack_public_path__ + "static/caroma logo-4277b47f85ef7074129574ec5344b84d.jpg";